/* eslint-disable @typescript-eslint/no-require-imports */
import type { GoogleGeminiNanoService } from "$src/core/services/search-classification/types";
import CustomPlatform from "$src/core/utils/platform/platform";

const unavailable: GoogleGeminiNanoService = {
  status: "unavailable",
  prepare: async () => undefined,
  classify: async () => null,
};

export default CustomPlatform.select<() => GoogleGeminiNanoService>({
  android: () => require("./google-gemini-nano.android").default,
  default: () => unavailable,
})();
